module.exports = __webpack_public_path__ + "static/media/people3.06534274.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/people3.jpg
// module id = 46
// module chunks = 0